<template>
	<div
		v-if="user.member_id"
		class="full-height"
	>
		<div>
			<div class="mt-10 justify-space-between">
				<h6>현장 인원 목록</h6>

				<button
					v-if="user.member_level >= 3"
					class="btn btn-primary"

					@click="toItem"
				>현장 인원 등록</button>
			</div>
		</div>

		<div class="mt-10">
			<ul
				v-if="item_list.length > 0"
			>
				<template
					v-for="member in item_list"
				>
					<li
						:key="member.uid"

						class="box radius-10 pa-10 cursor-pointer mb-10"

					>
						<div
							class="size-px-16  justify-space-between gap-10"
							@click="toView(member)"
						>{{ member.member_name}} ({{ member.member_id}}) <span>{{ member.member_level_name }}</span></div>
						<div
							v-if="member.member_id != user.member_id"
							class="mt-10 text-right justify-space-between"
						>

							<span
								@click="toView(member)"
								class="flex-1 text-left"
							>{{ member.member_tell }}</span>
							<button
								@click="setStatus(member)"
							>
								<v-icon
									v-if="member.member_status == '1'"
									class="color-primary"
									large
								>mdi mdi-toggle-switch</v-icon>
								<v-icon
									v-else
									large
								>mdi mdi-toggle-switch-off</v-icon>
							</button>
						</div>
					</li>
				</template>

				<Pagination
					:program="program"
					:align="'center'"
					:options="item_search"

					@click="getData"

					class="mt-auto pa-10"
				></Pagination>
			</ul>

			<Empty
				v-else
				class="mt-10"
			></Empty>
		</div>
	</div>
</template>

<script>
	import Empty from "../Layout/Empty";
	import Pagination from "../../components/Pagination";
	export default {
		name: 'MemberList'
		,
		components: {Pagination, Empty},
		props: ['user']
		, data: function(){
			return {
				program: {
					name: '현장 인원 목록'
					,title: false
					,search: true
					,bottom: true
					, is_container: true
				}
				, items: []
				, item_search: {
					page: 1
					, list_cnt: 10
				}
			}
		}
		, computed: {
			item_list: function(){
				return this.items.filter( (item) => {
					return item
				})
			}
		}
		, methods: {
			getData: async function(){
				this.$bus.$emit('on', true)
				try {
					const result = await this.$request.init({
						method: 'get'
						, url: 'Projectmember/getMemberList'
						, data: this.item_search
					})

					if (result.success) {

						this.items = result.data.result
						this.$set(this.item_search, 'total_count', result.data.tCnt)
						this.$storage.setQuery(this.item_search)

					} else {
						this.$bus.$emit('notify', {type: 'error', message: result.message})
					}
				}catch (e) {
					console.log(e)
				}finally {
					this.$bus.$emit('on', false)
				}
			}
			, getSearch: function(page = 1){
				if(page){
					this.item_search.page = page
				}

				this.getData()
			}
			, toItem: function(){
				this.$bus.$emit('to', { name: 'MemberItem'})
			}
			, toView: function(member){
				this.$bus.$emit('to', { name: 'MemberView', params: {idx: member.uid}})
			}
			, setStatus: async function(member_info){

				if(member_info.member_id != this.user.member_id){
					this.$set(member_info, 'member_status', member_info.member_status == '1' ? member_info.member_status = '0' : member_info.member_status = '1')
				}

				this.$bus.$emit('on', true)
				try {
					const result = await this.$request.init({
						method: 'post'
						, url: 'projectmember/putMemberStatus'
						, data: {
							idx: member_info.uid
							, member_status: member_info.member_status
						}
					})

					if(result.success){
						//
					}else{
						throw result.message
					}
				}catch (e){
					this.$bus.$emit('notify', { type: 'error', message: e})
				}finally {
					this.$bus.$emit('on', false)
				}
			}
		}
		, created() {
			this.$bus.$emit('onLoad', this.program)
			if(!this.user.member_level || this.user.member_level < 3){
				this.$bus.$emit('goBack');
			}else{
				this.getData()
			}
		}
	}
</script>

<style>
.v-icon.v-icon { line-height: unset}
</style>